<template>
	<inertia-head title="Home" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h1 class="fw-bold text-white mb-2">Profile</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Manage your profile information
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="row border-bottom">
			<div class="col-xl-4 col-lg-4 col-md-12 mb-4">
				<h6 class="mb-1 fs-md">Profile Information</h6>
				<small class="text-muted">
					Update your account's profile information and email address.
				</small>
			</div>
			<div class="col-xl-8 col-lg-8 col-md-12">
				<div class="block block-rounded">
					<div class="block-content block-content-full">
						<div class="row">
							<div class="col-xl-8 col-lg-8">
								<form action="">
									<div class="mb-4">
										<label class="form-label" for="firstname">
											Firstname
										</label>
										<input
											v-model="form.firstname"
											type="text"
											class="form-control"
											id="firstname"
										/>
									</div>
									<div class="mb-4">
										<label class="form-label" for="lastname">Lastname</label>
										<input
											v-model="form.lastname"
											type="text"
											class="form-control"
											id="lastname"
										/>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3'
import { onMounted } from 'vue'
import AuthLayout from '../../Layouts/AuthLayout'

export default {
	layout: AuthLayout,
	props: {
		user: Object,
		flash: Object,
		errors: Object,
		beneficiaries: Object,
		browserSessions: Object,
	},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const form = useForm({
			firstname: props.user.fname,
			lastname: props.user.lname,
			email: props.user.email,
			birthdate: props.user.bday,
			gender: props.user.gender,
			bday: props.user.bday,
			mobile: props.user.mobile,
			country_code: props.user.country_code,
		})

		return {
			form,
		}
	},
}
</script>
